import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import renderHTML from 'react-render-html'

import '../../styles/css/components/loyalty/disloyalty-banner.css'

class DisloyaltyBanner extends Component {
  render() {
    const {hotelCode} = this.props
    const disloyaltyAssets = this.props[hotelCode]

    return (disloyaltyAssets
      ? (
          <div 
            className="bk-flow-disloyalty-banner" 
            style={{backgroundImage: `url(${disloyaltyAssets.bannerBackground})`}}
          >
            <div className="disloyalty-logo">
              <img alt="Dis-Loyalty" src={disloyaltyAssets.bannerLogo} />
            </div>
            <div className="disloyalty-banner-text">
              <div className="banner-one">
                {renderHTML(get(disloyaltyAssets, 'copy[0]', ''))}
              </div>
              <div className="banner-two">
                {renderHTML(get(disloyaltyAssets, 'copy[1]', ''))}
              </div>
              <p className="disloyalty-terms disloyalty-terms-desktop">{renderHTML(disloyaltyAssets.bottomNote)}</p>
            </div>
            <a
              className="disloyalty-button"
              href={get(disloyaltyAssets, 'link.url')}
              target='_blank'
            >
              {get(disloyaltyAssets, 'link.text')}
            </a>
            <p className="disloyalty-terms disloyalty-terms-mobile">{renderHTML(disloyaltyAssets.bottomNote)}</p>
          </div>
        )
      : null)
  }
}

const mapStateToProps = state => ({
  ...get(state, 'hotelContentFeeds.feeds.exclusiveBenefits.assets')
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DisloyaltyBanner)



// WEBPACK FOOTER //
// ./src/components/loyalty/DisloyaltyBanner.js